export const TextField = 'TextField' as const;

export const GIRA_ISSUE_ERROR_ANALYTICS = 'issue.error.gira';
